import { Camera, CarFront, HardDrive } from "lucide-react";

const icons = [CarFront, Camera, HardDrive];

export function Solutions({ content, images = [] }) {
  return (
    <>
      <section id="solutions" className="section solutions-intro-section" data-testid="solutions-section">
        <div className="section-heading wide">
          <p className="overline" data-testid="solutions-overline">{content.overline}</p>
          <h2 data-testid="solutions-title">{content.title}</h2>
        </div>
        <div className="solution-grid solution-overview-grid" data-testid="solution-overview-cards">
          {content.domains.map((domain, index) => {
            const Icon = icons[index];
            return (
              <article className="solution-card compact" key={domain.title} data-testid={`solution-overview-card-${index + 1}`}>
                <div className="solution-icon" data-testid={`solution-overview-icon-${index + 1}`}><Icon size={24} aria-hidden="true" /></div>
                <p className="card-eyebrow" data-testid={`solution-overview-eyebrow-${index + 1}`}>{domain.eyebrow}</p>
                <h3 data-testid={`solution-overview-title-${index + 1}`}>{domain.title}</h3>
              </article>
            );
          })}
        </div>
      </section>

      <section className="section solutions-detail-section" data-testid="solutions-detail-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="solutions-detail-overline">{content.overline}</p>
          <h2 data-testid="solutions-detail-title">{content.domains?.[0]?.title}</h2>
        </div>
        <div className="solution-grid" data-testid="solution-cards">
        {content.domains.map((domain, index) => {
          const Icon = icons[index];
          const image = images[index];
          return (
            <article className="solution-card" key={domain.title} data-testid={`solution-card-${index + 1}`}>
              {image ? (
                <div className="solution-image" data-testid={`solution-image-${index + 1}`}>
                  <img src={image} alt={domain.title} />
                </div>
              ) : null}
              <div className="solution-icon" data-testid={`solution-icon-${index + 1}`}>
                <Icon size={24} aria-hidden="true" />
              </div>
              <p className="card-eyebrow" data-testid={`solution-eyebrow-${index + 1}`}>{domain.eyebrow}</p>
              <h3 data-testid={`solution-title-${index + 1}`}>{domain.title}</h3>
              <p className="solution-description" data-testid={`solution-description-${index + 1}`}>{domain.description}</p>

              <ul className="feature-list" data-testid={`solution-feature-list-${index + 1}`}>
                {domain.items.map((item) => (
                  <li key={item} data-testid={`solution-feature-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
                ))}
              </ul>

              <div className="product-tags" data-testid={`solution-product-tags-${index + 1}`}>
                {domain.products.map((product) => (
                  <span key={product} data-testid={`solution-product-${product.toLowerCase().replaceAll(" ", "-")}`}>{product}</span>
                ))}
              </div>
            </article>
          );
        })}
        </div>
      </section>
    </>
  );
}